<template>
<div class="top-bar-background">
    <div class="header-container">
        <div class="nav-container">
            <div @click="$router.push({ path: '/' })" class="website-name-container"> 
                <img style="margin: 7px;" src="@/assets/images/logo-threadok.svg" @click="$router.push({ path: '/' })">
                <div class="website-name">ThreadOk</div>
                <p style="opacity: 0.5; margin-left: 10px; font-size: 20px;">|</p>
                <p style="opacity: 0.5; margin-left: 10px;">The first place to share and find great Twitter threads</p>
            </div>
            <div> 
                <button class="secondary-button" style="float: right; margin-right: 0px;" v-if="$store.state.auth.isLogged" @click="$router.push({ path: '/profile' })">Profile</button>
                <button class="primary-button" style="float: right; margin-right: 0px;" v-if="!$store.state.auth.isLogged" @click="$router.push({ path: '/register' })">Sign up</button>
                <button class="secondary-button" style="float: right; margin-right: 0px;" v-if="!$store.state.auth.isLogged" @click="$router.push({ path: '/login' })">Log in</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>